export default __webpack_public_path__ + "static/benefits_4-aa54b0bfc10220eec424dbb71f694f0a.webp";